/* eslint-disable @typescript-eslint/no-unused-expressions */
import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { useTranslation } from 'react-i18next'

import { DataApi, QUERY_KEYS } from '@api'

const usePostBatchBilling = () => {
  const queryClient = useQueryClient()
  const { t } = useTranslation()

  const closeBatchSuccess = () => {
    notification.success({
      message: t('Lote cerrado correctamente'),
    })
    queryClient.invalidateQueries(QUERY_KEYS.BILLING_BATCH)
  }

  const closeBatchError = () => {
    notification.error({
      message: t('Error al cerrar el lote'),
    })
  }

  const { mutate: closeBatch, isLoading: closeBatchLoading } = useMutation(
    (id: number) => DataApi.updateBillingBatch(id),
    {
      onSuccess: closeBatchSuccess,
      onError: closeBatchError,
    },
  )

  return {
    closeBatch,
    closeBatchLoading,
  }
}

export { usePostBatchBilling }
